// Generated by ReScript, PLEASE EDIT WITH CARE

import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as Kontent$PrezzeeRibbon from "../../personal/Kontent/Kontent.bs.js";

var listStyling = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.listStyleType("none"),
      BsCssJs$PrezzeeRibbon.margin(BsCssJs$PrezzeeRibbon.zero),
      BsCssJs$PrezzeeRibbon.padding(BsCssJs$PrezzeeRibbon.zero),
      BsCssJs$PrezzeeRibbon.fontSize(BsCssJs$PrezzeeRibbon.px(15)),
      BsCssJs$PrezzeeRibbon.lineHeight(BsCssJs$PrezzeeRibbon.em(2)),
      BsCssJs$PrezzeeRibbon.fontWeight("normal")
    ]);

var Styles = {
  listStyling: listStyling
};

function Footer__LinkList(props) {
  return JsxRuntime.jsx(Kontent$PrezzeeRibbon.Consumer.make, {
              children: JsxRuntime.jsx("ul", {
                    children: props.children,
                    className: listStyling
                  })
            });
}

var make = Footer__LinkList;

export {
  Styles ,
  make ,
}
/* listStyling Not a pure module */
